import { render } from "./ThreeScene.vue?vue&type=template&id=508aaaf7&scoped=true"
import script from "./ThreeScene.vue?vue&type=script&lang=js"
export * from "./ThreeScene.vue?vue&type=script&lang=js"

import "./ThreeScene.vue?vue&type=style&index=0&id=508aaaf7&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508aaaf7"]])

export default __exports__